import { AbstractControl } from "@angular/forms";

/**
 * Filters out a set of errors from the error list of a control.
 *
 * @param control - Control with errors we want to filter out.
 * @param errorsToIgnore - A set of errors we want to filter out.
 */
export const filterOutErrors = (control: AbstractControl, errorsToIgnore: Set<string>): string[] => {
	if (!control) {
		return [];
	}

	const { errors } = control;

	if (!errors) {
		return [];
	}

	return Object.keys(errors).filter((error) => !errorsToIgnore.has(error));
};
